// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Atom_Box from "./Atom_Box.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Particle_Css from "../particle/Particle_Css.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";

function Atom_Grid(Props) {
  var accessibility = Props.accessibility;
  var alignItems = Props.alignItems;
  var alignSelf = Props.alignSelf;
  var area = Props.area;
  var autoSize = Props.autoSize;
  var background = Props.background;
  var blockSpaceOpt = Props.blockSpace;
  var border = Props.border;
  var children = Props.children;
  var deviceRules = Props.deviceRules;
  var displayOrder = Props.displayOrder;
  var gap = Props.gap;
  var gapColumn = Props.gapColumn;
  var gapRow = Props.gapRow;
  var height = Props.height;
  var id = Props.id;
  var identifier = Props.identifier;
  var justifyContent = Props.justifyContent;
  var kind = Props.kind;
  var maxWidth = Props.maxWidth;
  var rules = Props.rules;
  var width = Props.width;
  var ref_ = Props.ref_;
  var blockSpace = blockSpaceOpt !== undefined ? Caml_option.valFromOption(blockSpaceOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeNone(undefined));
  var empty = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);
  var gapColumnRules = Belt_Option.mapWithDefault(gapColumn, empty, (function (dsScreen) {
          return Particle_Screen_Ds.map((function (value) {
                        return [CssJs.gridColumnGap(Particle_Css.spacerSizeInside(value))];
                      }), dsScreen);
        }));
  var gapRowRules = Belt_Option.mapWithDefault(gapRow, empty, (function (dsScreen) {
          return Particle_Screen_Ds.map((function (value) {
                        return [CssJs.gridRowGap(Particle_Css.spacerSizeInside(value))];
                      }), dsScreen);
        }));
  var rules$1 = Particle_Screen_Ds.$$Array.concatOrDefault(Particle_Screen_Ds.$$Array.concat(gapRowRules, gapColumnRules), rules);
  var tmp = {
    children: children,
    direction: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "row"),
    display: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.grid),
    rules: rules$1,
    spacer: blockSpace
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (alignItems !== undefined) {
    tmp.alignItems = Caml_option.valFromOption(alignItems);
  }
  if (alignSelf !== undefined) {
    tmp.alignSelf = Caml_option.valFromOption(alignSelf);
  }
  if (area !== undefined) {
    tmp.area = area;
  }
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (background !== undefined) {
    tmp.background = Caml_option.valFromOption(background);
  }
  if (border !== undefined) {
    tmp.border = Caml_option.valFromOption(border);
  }
  if (deviceRules !== undefined) {
    tmp.deviceRules = Caml_option.valFromOption(deviceRules);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (gap !== undefined) {
    tmp.gap = Caml_option.valFromOption(gap);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (identifier !== undefined) {
    tmp.identifier = identifier;
  }
  if (justifyContent !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(justifyContent);
  }
  if (kind !== undefined) {
    tmp.kind = Caml_option.valFromOption(kind);
  }
  if (maxWidth !== undefined) {
    tmp.maxWidth = Caml_option.valFromOption(maxWidth);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Box.make, tmp);
}

Atom_Grid.displayName = "Grid";

var make = Atom_Grid;

export {
  make ,
}
/*  Not a pure module */
